var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"c-row c-horizontal-center ui-mb-4"},[_c('div',{staticClass:"c-col-2 sm:c-col-6 md:c-col-12 lg:c-col-10"},[_c('p-breadcrumb')],1)]),_c('router-view',_vm._g(_vm._b({},'router-view',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }